export default "<ion-spinner class=\"spinner\" color=\"secondary\"></ion-spinner>\n<img class=\"inner-img\" [src]=\"img\" (load)=\"onImgLoad()\"/>\n\n";